module.exports = __webpack_public_path__ + "img/maintop.92b43dc.png";